import { useRoute } from '@react-navigation/native'
import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { calculateEMI } from '../functions/calculateEMI'

export const useCalculateEMI = () => {
  const toast = useToast()
  const { params } = useRoute()
  const { hash } = params ?? {}

  return useMutation({
    mutationFn: ({ amount, tenure }: { amount: number; tenure: number }) => {
      return calculateEMI({ hash, amount, tenure })
    },
    onError: () => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
